import { useState, useEffect } from "react";
import { BillingRate } from "../../types/schema";
import "../../css/UserEditModal.css";
import "../../css/SiteAdminModals.css";

interface EditBillingRatesModalProps {
    isOpen: boolean;
    onClose: () => void;
    billingRate: BillingRate | null;
    onSave: (rates: Partial<BillingRate>) => void;
}

export const EditBillingRatesModal = ({ isOpen, onClose, billingRate, onSave }: EditBillingRatesModalProps) => {
    const [rates, setRates] = useState({
        ratePerUser: 0, ratePerEquipment: 0, ratePerPM: 0,
        ratePerTireMaint: 0, ratePerCostTracking: 0,
        ratePerSafetyEnrollment: 0, ratePerSkillQualification: 0,
    });

    useEffect(() => {
        if (billingRate) {
            setRates({
                ratePerUser: billingRate.ratePerUser || 0,
                ratePerEquipment: billingRate.ratePerEquipment || 0,
                ratePerPM: billingRate.ratePerPM || 0,
                ratePerTireMaint: billingRate.ratePerTireMaint || 0,
                ratePerCostTracking: billingRate.ratePerCostTracking || 0,
                ratePerSafetyEnrollment: billingRate.ratePerSafetyEnrollment || 0,
                ratePerSkillQualification: billingRate.ratePerSkillQualification || 0,
            });
        }
    }, [billingRate]);

    if (!isOpen) return null;

    const update = (field: string, value: string) => {
        setRates((prev) => ({ ...prev, [field]: parseFloat(value) || 0 }));
    };

    return (
        <div className="uem-overlay" onClick={onClose}>
            <div className="uem-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
                <div className="uem-header">
                    <h2>Edit Billing Rates</h2>
                    <button className="uem-close" onClick={onClose} aria-label="Close">×</button>
                </div>
                <div className="uem-body">
                    <p className="uem-modal-desc">Set the monthly billing rate for each module. Counts are pulled automatically from the system (PM uses configured PM forms).</p>

                    <label className="uem-section-label">Core — Always Billed</label>
                    <div className="uem-field-row" style={{ marginBottom: 16 }}>
                        <div className="uem-field">
                            <label>Rate per User / mo</label>
                            <input type="number" step="0.01" value={rates.ratePerUser} onChange={(e) => update("ratePerUser", e.target.value)} />
                        </div>
                        <div className="uem-field">
                            <label>Rate per Equipment / mo</label>
                            <input type="number" step="0.01" value={rates.ratePerEquipment} onChange={(e) => update("ratePerEquipment", e.target.value)} />
                        </div>
                    </div>

                    <label className="uem-section-label">Add-On Modules</label>
                    <div className="uem-field-row" style={{ marginBottom: 12 }}>
                        <div className="uem-field">
                            <label>Rate per PM Form / mo</label>
                            <input type="number" step="0.01" value={rates.ratePerPM} onChange={(e) => update("ratePerPM", e.target.value)} />
                        </div>
                        <div className="uem-field">
                            <label>Rate per Tire Maint. / mo</label>
                            <input type="number" step="0.01" value={rates.ratePerTireMaint} onChange={(e) => update("ratePerTireMaint", e.target.value)} />
                        </div>
                    </div>
                    <div className="uem-field-row" style={{ marginBottom: 12 }}>
                        <div className="uem-field">
                            <label>Rate per Cost Tracking / mo</label>
                            <input type="number" step="0.01" value={rates.ratePerCostTracking} onChange={(e) => update("ratePerCostTracking", e.target.value)} />
                        </div>
                        <div className="uem-field">
                            <label>Rate per Safety Enrollment / mo</label>
                            <input type="number" step="0.01" value={rates.ratePerSafetyEnrollment} onChange={(e) => update("ratePerSafetyEnrollment", e.target.value)} />
                        </div>
                    </div>
                    <div className="uem-section">
                        <div className="uem-field">
                            <label>Rate per Skill Qualification / mo</label>
                            <input type="number" step="0.01" value={rates.ratePerSkillQualification} onChange={(e) => update("ratePerSkillQualification", e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className="uem-footer">
                    <button type="button" className="uem-btn-cancel" onClick={onClose}>Cancel</button>
                    <button type="button" className="uem-btn-submit" onClick={() => onSave(rates)}>Save Rates</button>
                </div>
            </div>
        </div>
    );
};
